/**
* Nom : targetNew.js
* Description : Ce fichier contient la définition de la page targetNew 
*               Cette page fourni un formulaire pour créer une cible
* Date de création : 23 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { SelectForm} from 'package_ui_ihm/dist'
import { InputForm } from 'package_ui_ihm/dist'
import { ImageForm } from 'package_ui_ihm/dist'

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useNavigate } from 'react-router-dom'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TargetNew : affiche une page avec un formulaire pour créer une cible
*             un lien permet de revenir sur la page qui liste toutes les cibles 
*
* Type : page 
*
* Parametres : 
*  None
*/
function TargetNew() {

    // Define useState hooks
    const [name, setName] = useState('');
    const [selectedCat, setSelectedCat] = useState(0);
    const [selectedVar, setSelectedVar] = useState(0);
    const [selectedType, setSelectedType] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const [hormesisMin, setHormesisMin] = useState(0);
    const [hormesisMax, setHormesisMax] = useState(0);
    const [prevCat, setPrevCat] = useState(0);
    const [categories, setCategories] = useState([])
    const [varieties, setVarieties] = useState([])
    const [filteredVarieties, setFilteredVarieties] = useState(varieties);
    const [target, setTarget] = useState(null)
    const [statusTarget, setStatusTarget] = useState(null)
    const [nameError, setNameError] = useState(false);
    const [categoryError, setCategoryError] = useState(false);
    const [varietyError, setVarietyError] = useState(false);
    const [typeError, setTypeError] = useState(false);
    const [hormesisMinError, setHormesisMinError] = useState(false);
    const [hormesisMaxError, setHormesisMaxError] = useState(false);
    const [formSubmit, setFormSubmit] = useState(false);
    const [skipPrompt, setSkipPrompt] = useState(false);


    // Define useContext hooks
    const { authStatus, authToken } = useAuth();
    const { path } = useApi();
    const { targetTypes } = useData();

    const navigate = useNavigate();


    // Define useBlocker hooks
    const shouldBlock = 
        ((selectedCat !== "0" && selectedCat !== 0) || 
        (selectedVar !== "0" && selectedVar !== 0) ||
        (selectedType !== "0" && selectedType !== 0) ||
        (hormesisMin !== 0) ||
        (hormesisMax !== 0)) && 
        (skipPrompt === false);
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(name, category_id, variety_id, type_id, url_image, hormesis_min, hormesis_max) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        if (url_image){
            form_data.append("url_image", url_image, url_image.name);
        }
        form_data.append("name", name);
        form_data.append("category_id", Number(category_id));
        form_data.append("variety_id", Number(variety_id));
        form_data.append("target_type_id", Number(type_id));
        form_data.append("hormesis_min", Number(hormesis_min));
        form_data.append("hormesis_max", Number(hormesis_max));
        // Create target 
        const response = await fetch(path + "/api/bo-taet/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        const data = await response.json();
        setStatusTarget(response["status"])
        setTarget(data)
        setFormSubmit(false)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSkipPrompt(true);
        if(name === null || name === ''){
            setNameError(true)
        }
        else
        {   
            setNameError(false)
        }
        if(selectedCat === 0 || selectedCat === '0'){
            setCategoryError(true)
        }
        else
        {   
            setCategoryError(false)
        }
        if(selectedVar === 0 || selectedVar === '0'){
            setVarietyError(true)
        }
        else
        {   
            setVarietyError(false)
        }
        if(selectedType === 0 || selectedType === '0'){
            setTypeError(true)
        }
        else
        {   
            setTypeError(false)
        }
        if(hormesisMin === null){
            setHormesisMinError(true)
        }
        else
        {   
            setHormesisMinError(false)
        }
        if(hormesisMax === null){
            setHormesisMaxError(true)
        }
        else
        {   
            setHormesisMaxError(false)
        }
        setFormSubmit(true)
    };

    function updateFilteredVarieties() {
        // Check category change to reinit variety
        if(selectedCat !== prevCat)
        {
            setSelectedVar(0);
            setPrevCat(selectedCat);
        }
        // Filtering of varieties
        if( selectedCat > 0 )
        {
            setFilteredVarieties(varieties.filter((variety) => variety.category_id === Number(selectedCat)))
        }  
        else
        {
            setFilteredVarieties(varieties)
        }
    }

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resCategory, resVariety] = await Promise.all([
            // Categories
            fetch(path + "/api/bo-cary/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Varieties
            fetch(path + "/api/bo-vaty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataCategory, dataVariety] = await Promise.all([
            resCategory.json(),
            resVariety.json(),
        ])
        // Set variables
        setCategories(dataCategory["results"])
        setVarieties(dataVariety["results"])
    }

    function handleFileChange (event) {
        const file = event.target.files[0];
        setSelectedImage(file);
    };


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        updateFilteredVarieties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCat])

    useEffect(() => {
        var catName = ''
        var varName = ''
        var typeName = ''
        if(categories.length !== 0 && Number(selectedCat) > 0)
        {
            catName = (categories.find((cat) => cat['id'] === Number(selectedCat)))['name']
        }
        if(filteredVarieties.length !== 0 && Number(selectedVar) > 0)
        {
            varName = (varieties.find((variety) => variety['id'] === Number(selectedVar)))['name']
        }
        if(targetTypes.length !== 0 && Number(selectedType) > 0)
        {
            typeName = (targetTypes.find((type) => type['id'] === Number(selectedType)))['name']
        }
        setName(catName + ' ' + varName + ' ' + typeName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCat, selectedVar, selectedType])

    useEffect(() => {
        if(formSubmit === true && nameError === false && categoryError === false && varietyError === false && typeError === false && hormesisMinError === false && hormesisMaxError === false){
            sendData(name, selectedCat, selectedVar, selectedType, selectedImage, hormesisMin, hormesisMax)
        } else {
            setSkipPrompt(false);
            setFormSubmit(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formSubmit])

    useEffect(() => {
        if(statusTarget === 201) {
            const target_path = '/targets/' + target["id"]
            navigate(target_path)
        } else {
            setFormSubmit(false)
            navigate('/targets/new')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusTarget, navigate]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
            if (shouldBlock === true) {
                // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
                e.preventDefault();
                e.returnValue = "";
                // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
                return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
            }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <TabRD tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    <h1>Créer une nouvelle cible</h1>
                    {/*Lien de retour*/}
                    <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                        <div className='link-border'>
                            <BackPage path='/targets'>Retour à la liste des cibles</BackPage>
                        </div>
                    </div>
                    {(statusTarget !== null && statusTarget !== 201 && nameError === false && categoryError === false && varietyError === false && typeError === false) ? (
                        <p className='form-error'>La cible existe déjà ou n'a pas pu être enregistrée !</p>
                    ) : (
                        <p/>
                    )}  
                    <form onSubmit={handleSubmit} className='flex-column'>
                        <div className='flex-column form-center'>
                            <InputForm error={nameError} type="text" label="Nom" value={name} setValue={setName} disabled={true}/>
                            <SelectForm error={categoryError} labelText='Catégorie' choices={categories.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedCat} setSelectedItem={setSelectedCat}/>
                            <SelectForm error={varietyError} labelText='Variété' choices={filteredVarieties.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedVar} setSelectedItem={setSelectedVar}/>
                            <SelectForm error={typeError} labelText='Type de cible' choices={targetTypes.sort((a, b) => (a.name > b.name)?1:-1)} selectedItem={selectedType} setSelectedItem={setSelectedType}/>
                            <ImageForm label="Photo" onChangeFunc={handleFileChange} currentValue={null}/>  
                            <InputForm error={hormesisMinError} type="number" label="Hormèse min (mJ/cm²)" value={hormesisMin} setValue={setHormesisMin} disabled={false}/>
                            <InputForm error={hormesisMaxError} type="number" label="Hormèse max (mJ/cm²)" value={hormesisMax} setValue={setHormesisMax} disabled={false}/>  
                            <div></div>               
                        </div>
                        <div className='flex-column form-right'>
                            <button type="submit" className='button'>Valider</button>
                        </div>
                    </form> 
                </Container>
            </div>
        </div>
    );
}

export default TargetNew;
